<template>
  <div>
    <div class="header">
      <div class="header_color">
        <div class="header_child">
          <p class="wang">你好，欢迎访问十九路赛事网、喜欢本站请收藏！</p>
          <div class="logo_sign">
            <p @click="sign">立即登录</p>
            <p class="logo_signp" @click="logo">|免费注册</p>
          </div>
        </div>
      </div>
      <div class="header_logo">
        <div class="logo">
          <img src="@/assets/logo.jpg" alt />
        </div>
        <div class="header_suo">
          <input
            type="text"
            name
            id
            class="header_input"
            placeholder="输入关键字"
            v-model="title"
            value="value"
          />
          <button class="bnt" @click="gets_app">赛事检索</button>
        </div>
      </div>
      <div class="nav">
        <ul class="nav_ul">
          <li @click="index">首页</li>
          <li @click="competition">赛事信息</li>
          <li @click="journalism">新闻报道</li>
          <li>赛事专题</li>
          <li @click="about">关于我们</li>
          <li @click="contact">联系我们</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      page: "1",
      pageSize: "8",
      matchData: [],
      value: ""
    };
  },
  watch: {},
  methods: {
    index() {
      this.$router.push({
        path: "/index"
      });
    },
    competition() {
      this.$router.push({
        path: "/competition"
      });
    },
    journalism() {
      this.$router.push({
        path: "/journalism"
      });
    },
    sign() {
      this.$router.push({
        path: "/signIn"
      });
    },
    logo() {
      this.$router.push({
        path: "/signIn"
      });
    },
    contact() {
      this.$router.push({
        path: "/contact"
      });
    },
    about() {
      this.$router.push({
        path: "/about"
      });
    },
    gets_app: function() {
      if (this.title == "") {
        alert("内容不能为空");
      } else {
        this.$emit("messageData", this.title);
        console.log(this.title);
      }
    }
  },
  mounted() {}
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.header {
  width: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
}

.header_color {
  width: 100%;
  background: #f0f0f0;
  line-height: 0.36rem;
  font-size: 0.16rem;
}
.header_child {
  width: 76%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.logo_sign {
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}
.logo_signp {
  margin-left: 0.05rem;
}
.header_logo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 70%;
  margin: 0 auto;
  margin-top: 10px;
  height: 0.9rem;
}
.logo {
  width: 2.74rem;
  height: 0.66rem;
}
.logo img {
  width: 2.74rem;
  float: left;
}
.header_suo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.header_input {
  width: 2.8rem;
  height: 0.36rem;
  line-height: 0.36rem;
  outline: none;
  border: none;
  border: solid #ccc 1px;
  padding-left: 5px;
  margin-top: 0.14rem;
}
.bnt {
  width: 1.02rem;
  height: 0.38rem;
  background-color: #00a4fe;
  color: #fff;
  outline: none;
  border: none;
  margin-top: 0.14rem;
}
.nav {
  width: 100%;
  line-height: 0.5rem;
  background: #e50006;
  color: #fff;
}
.nav_ul {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  width: 70%;
  margin: 0 auto;
  font-size: 0.16rem;
}
.nav_ul li {
  /* width: 1rem; */
  text-align: center;
  cursor: pointer;
  padding: 0 0.2rem;
}
.nav_ul li:hover {
  /* width: 1rem; */
  background: #fe8f24;
}
.wang {
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue